(ns ui.view.survey.modals.tesi-esg-errors
  (:require
   [common.localization :as loc]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.view.survey.event :as survey-view-event]
   [ui.view.survey.modals.sub :as sub]
   [ui.view.survey.sub :as survey-view-sub]))

(defn tesi-custom-import-failed-message
  [{:keys [errors]}]
  (if (map? errors)
    (let [error-keys (->> errors
                          (vals)
                          (apply merge)
                          (keys))
          missing-uid-error? (some #{:missing-error} error-keys)
          duplicate-uid-error? (some #{:duplicate-error} error-keys)]
      [:div
       {:class-name "pb-4 flex flex-col"}
       [:p
        {:class-name "pb-4"}
        (cond (and missing-uid-error? (not duplicate-uid-error?))
              (loc/tr :survey-import-error-1-missing)
              (and duplicate-uid-error? (not missing-uid-error?))
              (loc/tr :survey-import-error-1-duplicate)
              :else
              (loc/tr :survey-import-error-1))]
       [:p
        {:class-name "pb-4"}
        (loc/tr :survey-import-error-2)]
       [:p
        {:class-name "pb-4"}
        (loc/tr :survey-import-error-3)]
       (->> errors
            (map (fn [[sheet error-map]]
                   (let [error-list (->> error-map
                                         (vals)
                                         (apply concat))]
                     ^{:key (str sheet)}
                     [:div
                      (when sheet
                        [:p
                         {:class "font-semibold mb-1"}
                         (str (loc/tr :survey-import-sheet) sheet)])
                      [:ul
                       {:class "flex flex-col gap-2"}
                       (->> error-list
                            (map (fn [error-msg]
                                   ^{:key (str error-msg)}
                                   [:li
                                    {:class "text-danger text-sm ml-2 mb-0"}
                                    error-msg])))]]))))])
    (loc/tr errors)))


(defn tesi-custom-import-failed-footer
  [{:keys [hide!]}]
  [:div
   {:class "flex flex-row flex-auto"}
   [:div
    {:class "flex flex-row flex-auto content-stretch justify-content-end"}
    [button/secondary-hollow
     {:on-click hide!}
     (loc/tr :close)]]])

(defn view
  []
  (let [survey-id @(rf/subscribe [::sub/survey-id])
        errors @(rf/subscribe [::survey-view-sub/data-import-error survey-id])
        show? @(rf/subscribe [::survey-view-sub/tesi-custom-excel-import-failed? survey-id])
        hide! #(rf/dispatch [::survey-view-event/clear-errors-tesi survey-id])]
    [modal/view
     {:visible? show?
      :hide!    hide! 
      :size     :full}
     (loc/tr :survey-import-failed)
     [tesi-custom-import-failed-message
      {:errors errors}]
     [tesi-custom-import-failed-footer 
      {:survey-id survey-id
       :hide! hide!}]]))
